import React from 'react';
import { Navigation } from 'lucide-react';
export function LiveTraffic() {
  return <section className="py-24 px-6 lg:px-8 bg-white border-t border-gray-100" data-id="element-100">
      <div className="max-w-6xl mx-auto" data-id="element-101">
        <div className="text-center mb-12" data-id="element-102">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-2 flex items-center justify-center gap-3" data-id="element-103">
            <Navigation className="w-8 h-8 text-sylmar" data-id="element-104" />
            Tráfico en Vivo
          </h2>
          <p className="text-xl text-sylmar font-medium" data-id="element-105">Live Traffic Map</p>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto" data-id="element-106">
            Consulta las condiciones actuales de tráfico, accidentes y cierres
            de calles en Sylmar y sus alrededores en tiempo real.
          </p>
        </div>

        <div className="w-full h-[500px] md:h-[600px] rounded-3xl overflow-hidden shadow-xl border-4 border-softblue relative bg-gray-100" data-id="element-107">
          {/* Waze Live Map Iframe centrado en Sylmar, CA (Lat: 34.3088, Lon: -118.4452) */}
          <iframe src="https://embed.waze.com/iframe?zoom=13&lat=34.3088&lon=-118.4452&ct=livemap" width="100%" height="100%" allowFullScreen sandbox="allow-scripts allow-same-origin allow-popups allow-forms" style={{
          border: 0
        }} title="Mapa de Tráfico en Vivo de Sylmar" className="absolute inset-0 z-10" data-id="element-108"></iframe>
        </div>

        <div className="mt-6 text-center" data-id="element-109">
          <p className="text-sm text-gray-500 font-medium flex items-center justify-center gap-2" data-id="element-110">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-111"></span>
            Actualizado en tiempo real por la comunidad
          </p>
        </div>
      </div>
    </section>;
}